import React, { useState } from 'react';
import Select from "../../Component/Select";
import { addDays, formatDate } from "../../Utis/GlobalFunctions";
import axios from "axios";
import Swal from 'sweetalert2';
import CircularLoader from "../../Component/CircularLoader";
import logo from "../../assets/images/zubari-associate.jpg"
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
const ZuberiAssociation = () => {
    const [currentDate] = useState(new Date())
    const newDate = addDays(currentDate, 3);
    const [loading,setLoading] = useState(false)
    const [credentials,setCredentails] = useState({
        username: "Zuberi_Associat",
        password: "Live@za25",
        clientId: "s8ZHeaYJ3GfufcP",
        clientSecret: "EjsV0e0U5Tp2sxX"

        //ORANTECH
        // username: "Oraan_tech",
        // password: "P@ssw0rd",
        // clientId: "QjJLPSgmte17rXA",
        // clientSecret: "uM8AjQfPPde7BxL"
    });
    // State to handle form input values
    const [formData, setFormData] = useState({
        name: '',
        donationType: '',
        nationalIdentityNumber: '',
        phoneNumber: '',
        amount: '',
        currency: '',
        country:"",
        email:"",

    });

    // State to handle errors
    const [errors, setErrors] = useState({});


    let payload
    if(formData.currency === "PKR") {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                OrderAmount: formData?.amount,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.name,
                CustomerMobile: "",
                CustomerEmail: formData?.email,
                CustomerAddress: "",
                BillDetail01: [
                    {
                        customerMobile: formData?.phoneNumber,
                        country:formData?.country,
                        purposeOfDonation:formData?.donationType,
                        nationalIdentityNumber:formData?.nationalIdentityNumber,
                    }
                ]
            }
        ];
    }else {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                CurrencyAmount: formData?.amount,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.name,
                CustomerMobile: "",
                CustomerEmail: formData?.email,
                CustomerAddress: "",
                Currency: formData?.currency,
                IsConverted  : "true",
                BillDetail01: [
                    {
                        customerMobile: formData?.phoneNumber,
                        country:formData?.country,
                        purposeOfDonation:formData?.donationType,
                        nationalIdentityNumber:formData?.nationalIdentityNumber,
                    }
                ]
            }
        ];
    }


    const donationTypeData = [
        { id: 1, name: "Zakat", value: "Zakat" },
        { id: 2, name: "Khairat", value: "Khairat" },
        { id: 3, name: "Sadqa", value: "Sadqa" },
        { id: 4, name: "Fitra", value: "Fitra" },
        { id: 5, name: "Scholarship", value: "Scholarship" },
        { id: 6, name: "Donation", value: "Donation" },
        { id: 7, name: "Other", value: "Other" },

    ];

    const currencyData = [
        { id: 1, name: "PKR", value: "PKR" },
        { id: 2, name: "USD", value: "USD" },
        { id: 3, name: "AED", value: "AED" }
    ];

    const countryData = [
        { id: 1, name: "USA", value: "USA" },
        { id: 2, name: "UK", value: "UK" },
        { id: 3, name: "Pakistan", value: "Pakistan" },
        { id: 4, name: "Saudi Arabia", value: "SaudiArabia" },
        { id: 5, name: "Dubai", value: "Dubai" },
        { id: 6, name: "Turkey", value: "Turkey" },
        { id: 7, name: "United Arab Emirates", value: "UAE" },
        { id: 8, name: "Tajikistan", value: "Tajikistan" },
        { id: 9, name: "Netherlands", value: "Netherlands" },
        { id: 10, name: "Kuwait", value: "Kuwait" },
        { id: 11, name: "Iran", value: "Iran" },
        { id: 12, name: "Denmark", value: "Denmark" },
        { id: 13, name: "China", value: "China" },
        { id: 14, name: "Azerbaijan", value: "Azerbaijan" }
    ];
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Update the form data state
        setFormData({
            ...formData,
            [name]: value,
        });

        // Validate the specific field on change
        validateField(name, value);
    };

// Real-time field validation
    const validateField = (name, value) => {
        let fieldError = {};

        switch (name) {
            case "name":
                if (!value) {
                    fieldError.name = "Full Name is required.";
                } else {
                    fieldError.name = ""; // Clear error if input is valid
                }
                break;
                case "nationalIdentityNumber":
                    if (!value) {
                        fieldError.nationalIdentityNumber = "CNIC/NICOP is required.";
                    } else if (!/^\d{13}$/.test(value)) {
                        fieldError.nationalIdentityNumber = "CNIC/NICOP must be exactly 13 digits.";
                    } else {
                        fieldError.nationalIdentityNumber = ""; // Clear error if input is valid
                    }
                break;
            case "email":
                if (!value) {
                    fieldError.email = "Email is required.";
                } else if (!/\S+@\S+\.\S+/.test(value)) {
                    fieldError.email = "Email address is invalid.";
                } else {
                    fieldError.email = ""; // Clear error if input is valid
                }
                break;
            case "phoneNumber":
                if (!value) {
                    fieldError.phoneNumber = "Phone number is required.";
                } else {
                    fieldError.phoneNumber = ""; // Clear error if input is valid
                }
                break;
            case "amount":
                if (!value) {
                    fieldError.amount = "Amount is required.";
                } else {
                    fieldError.amount = ""; // Clear error if input is valid
                }
                break;
            // case "address":
            //     if (!value) {
            //         fieldError.address = "Address is required.";
            //     } else {
            //         fieldError.address = ""; // Clear error if input is valid
            //     }
            //     break;
            case "currency":
                if (!value) {
                    fieldError.currency = "Currency is required.";
                } else {
                    fieldError.currency = ""; // Clear error if input is valid
                }
                break;
            case "country":
                if (!value) {
                    fieldError.country = "Country is required.";
                } else {
                    fieldError.country = ""; // Clear error if input is valid
                }
                break;
            case "donationType":
                if (!value) {
                    fieldError.donationType = "Donation type is required.";
                } else {
                    fieldError.donationType = ""; // Clear error if input is valid
                }
                break;
            default:
                break;
        }

        // Update errors state
        setErrors((prevErrors) => ({
            ...prevErrors,
            ...fieldError,
        }));
    };



    // Validate form inputs
    const validateForm = () => {
        const newErrors = {};

        // Check if the name field is empty
        if (!formData.name) newErrors.name = "Name is required.";

        if (!formData.email) {
            newErrors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email address is invalid.";
        }

        // Check if the phone number field is empty
        if (!formData.phoneNumber) newErrors.phoneNumber = "PhoneNumber is required.";


        if (!formData.nationalIdentityNumber) newErrors.nationalIdentityNumber = "CNIC/NICOP is required.";


        // Check if the amount field is empty
        if (!formData.amount) newErrors.amount = "Amount is required.";

        // Check if the address field is empty
        // if (!formData.address) newErrors.address = "Address is required.";

        // Check if the currency is selected
        if (!formData.currency) newErrors.currency = "Currency is required.";
        if (!formData.country) newErrors.country = "Country is required.";

        // Check if donation type is selected
        if (!formData.donationType) newErrors.donationType = "Donation type is required.";

        // Update the error state
        setErrors(newErrors);

        // Return whether the form is valid or not
        return Object.keys(newErrors).length === 0;
    };

    const getAuthToken = async (clientId, clientSecret) => {
        const tokenResponse = await axios.post(`${process.env.REACT_APP_PAYPRO_LIVEAPI}/auth`, {
            clientid: clientId,
            clientsecret: clientSecret,
        });
        return tokenResponse.data.token;
    };

    const payproCreateOrder = async (e) => {
        e.preventDefault();



        // Validate the form before submission
        const isValid = validateForm();
        if (!isValid) {
            // If the form has errors, prevent submission
            return;
        }

        try {
            setLoading(true);
            const token = await getAuthToken(credentials.clientId, credentials.clientSecret);
            const headers = { 'token': token, 'Content-Type': 'application/json' };
            const url = `${process.env.REACT_APP_PAYPRO_LIVEAPI}/create-order`;
            const response = await axios.post(url, payload, { headers });

            if(response.data?.data[0].Status === "03") {
                console.log(response.data.data[1].Description)
                await Swal.fire({
                    icon: "error",
                    title: response?.data?.data[1]?.Description,
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
            }else {
                const marketplaceUrl = response.data?.data[1]?.Click2Pay
                await Swal.fire({
                    icon: "success",
                    title: "Redirecting to Marketplace",
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
                // window.top.location.href = marketplaceUrl+"&callback_url=https://fixit.org.pk/thankyou-for-your-contribution";
                window.top.location.href = marketplaceUrl;
            }

            // return response.data;


        } catch (error) {
            console.error('Error creating order:', error);
            setLoading(false)
        }

    }


    return (
        <div className="w-11/12 lg:w-2/4 md:w-4/5 bg-white border-4 rounded-lg shadow relative m-auto">
            <form className="p-6 space-y-6" onSubmit={payproCreateOrder}>
                <div className='w-full flex items-center justify-center'>
                    <img className='w-2/6' src={logo} alt={logo} />
                </div>
                <div className="grid grid-cols-6 gap-6">
                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">
                            Name <span>*</span>
                        </label>
                        <input
                            type="text"
                            name="name"
                            value={formData?.name}
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // Allow only letters and spaces
                                handleChange({ target: { name: "name", value } });
                            }}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Full Name"
                        />
                        {errors.name && <p className="text-red-600 text-sm">{errors.name}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">
                            Email <span>*</span>
                        </label>
                        <input
                            type="text"
                            name="email"
                            value={formData?.email}
                            onChange={handleChange}

                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Email"
                        />
                        {errors.email && <p className="text-red-600 text-sm">{errors.email}</p>}
                    </div>




                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">
                            CNIC / NICOP Number <span>*</span>
                        </label>
                        <input
                            type="text" // Change to text for better control
                            name="nationalIdentityNumber"
                            value={formData?.nationalIdentityNumber}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, ''); // Allow only numbers
                                if (value.length <= 13) {
                                    handleChange({ target: { name: "nationalIdentityNumber", value } });
                                }
                            }}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="XXXXXXXXXXXXX"
                            maxLength={13} // Prevent more than 13 characters
                        />
                        {errors.nationalIdentityNumber && <p className="text-red-600 text-sm">{errors.nationalIdentityNumber}</p>}
                    </div>


                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">
                            Phone Number <span>*</span>
                        </label>
                        <PhoneInput
                            inputStyle={{
                                width: "100%",            // w-full
                                backgroundColor: "#f9fafb", // bg-gray-50
                                border: "1px solid #d1d5db", // border border-gray-300
                                color: "#111827",         // text-gray-900
                                fontSize: "0.875rem",     // sm:text-sm
                                borderRadius: "0.5rem!important",   // rounded-lg
                                paddingTop: "20px",
                                paddingBottom: "20px", // p-3
                                outline: "none",          // Tailwind doesn't have direct equivalent, but avoids unwanted focus outlines
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)", // shadow-sm
                                transition: "border-color 0.2s, box-shadow 0.2s", // Smooth transition on focus
                            }}

                            country={"pk"} // Default country Pakistan (+92)
                            value={formData?.phoneNumber}
                            onChange={(value) => handleChange({ target: { name: "phoneNumber", value } })}
                            inputProps={{
                                name: "phoneNumber",
                                required: true,
                            }}
                            containerClass="w-full"
                            buttonClass="bg-transparent border-r border-gray-300"
                        />
                        {errors.phoneNumber && <p className="text-red-600 text-sm">{errors.phoneNumber}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Donation Purpose <span>*</span></label>
                        <Select
                            selectValue={formData?.donationType}
                            setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                            name="donationType"
                            data={donationTypeData}
                        />
                        {errors.donationType && <p className="text-red-600 text-sm">{errors.donationType}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Currency <span>*</span></label>
                        <Select
                            selectValue={formData?.currency}
                            setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                            name="currency"
                            data={currencyData}
                        />
                        {errors.currency && <p className="text-red-600 text-sm">{errors.currency}</p>}
                    </div>


                    {/*<div className="col-span-6 sm:col-span-3">*/}
                    {/*    <label className="text-md font-medium text-gray-900 block mb-2">Amount <span>*</span></label>*/}
                    {/*    <input*/}
                    {/*        type="text"*/}
                    {/*        name="amount"*/}
                    {/*        value={formData?.amount}*/}
                    {/*        onChange={handleChange}*/}
                    {/*        className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"*/}
                    {/*        placeholder="Amount"*/}
                    {/*    />*/}
                    {/*    {errors.amount && <p className="text-red-600 text-sm">{errors.amount}</p>}*/}
                    {/*</div>*/}

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">
                            Amount <span>*</span>
                        </label>
                        <div className="flex items-center border border-gray-300 shadow-sm bg-gray-50 rounded-lg focus-within:ring-cyan-600 focus-within:border-cyan-600">
                            {formData.currency === "" ? null : (
                                <span className="px-3 text-gray-500 text-sm">{formData?.currency}</span>
                            )}
                            <input
                                type="text"
                                name="amount"
                                value={formData?.amount}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                                    handleChange({ target: { name: "amount", value } });
                                }}
                                className={`bg-transparent flex-1 text-gray-900 sm:text-sm focus:outline-none pr-3 pt-3 pb-3  ${
                                    formData?.currency === "" ? "pl-3" : "pl-0"
                                }`}
                                placeholder="Amount"
                            />
                        </div>
                        {errors.amount && <p className="text-red-600 text-sm">{errors.amount}</p>}
                    </div>





                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Country <span>*</span></label>
                        <Select
                            selectValue={formData?.country}
                            setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                            name="country"
                            data={countryData}
                        />
                        {errors.country && <p className="text-red-600 text-sm">{errors.country}</p>}
                    </div>





                </div>

                <div className="flex items-center justify-center">
                    <button
                        type="submit"
                        className="flex items-center gap-1  py-2 px-4 text-white bg-cyan-500 hover:bg-cyan-700 focus:ring-4 focus:ring-cyan-200 font-medium rounded-lg text-sm"
                    >
                        Submit {loading ? <CircularLoader/> : null}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ZuberiAssociation;


